"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PageHero = function PageHeroComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData;
  var _sliceData$primary = sliceData.primary,
      pageHeroTitle = _sliceData$primary.page_hero_title,
      pageHeroIcon = _sliceData$primary.page_hero_icon,
      pageHeroSummary = _sliceData$primary.page_hero_summary;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-hero-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-hero__row"
  }, pageHeroIcon.url && /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-hero__icon-col"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "page-hero__icon",
    src: pageHeroIcon.url,
    alt: ""
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-hero__info-col"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "page-hero__title"
  }, dataClient.textToMarkdown(pageHeroTitle)), /*#__PURE__*/_react["default"].createElement("hr", {
    className: "page-hero__hr"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "page-hero__summary"
  }, dataClient.textToMarkdown(pageHeroSummary))))));
};

PageHero.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({}).isRequired
};
var _default = PageHero;
exports["default"] = _default;